import errorHandlers from './onError'
import { message as Message } from '../../plugins/resetMessage'
import { notification as Notification } from '../../plugins/resetNotification'
import { setLocal } from '../cache'
import { get as lodashGet, isString, isPlainObject } from 'lodash'
import { localCover, coverConfig } from '../securityUtil/index'
import { genErrorMessage } from './utils'
import { logBigResponse } from '@/util/tools'

const NORMAL_ERROR = '服务异常, 请联系值班的研发同事'
const NETWORK_ERROR = '请求异常, 请联系值班的研发同事'

export default function onResponse(instance) {
  instance.interceptors.response.use(onResponseSuccess, onResponseError)
}

async function onResponseSuccess(response) {
  const {
    config: { getter, useLocal, responseType },
    data
  } = response
  // 1、有设置过responseType，比如blob
  if (responseType && responseType !== 'json') {
    return data
  }
  logBigResponse(response)
  let messages = NORMAL_ERROR
  // 2、 特殊业务场景？
  if (data.result === '退出成功') return
  if (data || data.success || data.resCode === 'success') {
    if (getter && getter.code) {
      const code = lodashGet(data, getter.code)
      if (code == getter.successCode && code !== undefined) {
        const finalData =
          typeof getter.data === 'string' ? lodashGet(data, getter.data) || lodashGet(data, getter.info) : data // 部分crm-access返回data键名为info
        if (useLocal) {
          setLocal(useLocal, finalData)
        }
        // 3、成功
        return await proxyData(finalData, response)
      }
      if (!data.success) {
        messages = lodashGet(data, getter.message, NORMAL_ERROR)
        if (errorHandlers[code]) {
          errorHandlers[code](data, response)
          // 静默，阻止错误弹窗
          response.config.silent = true
        }
      } else {
        return response.data
      }
    }
    if (data.resCode === 'success') {
      return data
    } else if (data.resCode) {
      messages = data.msg
    }
  }
  // 5、404？
  if (data.result === 404) return
  if (response.data && response.data.result == 1) return response
  if (data && data.errorMsg && messages === NORMAL_ERROR) {
    messages = data.errorMsg
  }
  logError({
    type: 'warning',
    message: messages,
    response
  })
  if (errorHandlers[data.result]) {
    errorHandlers[data.result](data, response)
  }
  return Promise.reject(messages)
}
function onResponseError(error) {
  console.log('[http: onResponseError]: ', error.code)
  if (error.__CANCEL__) {
    error.message = '取消'
    return Promise.reject(error)
  }
  if (!error.response) {
    let title
    const message = NETWORK_ERROR
    // 只在onResponseError中判断是否超时。
    if (error.message?.indexOf?.('timeout') > -1) title = '请求超时'

    // 网络完全不通
    logError({
      message,
      config: error.config,
      code: error.code,
      title
    })
    return Promise.reject(error.message)
  }

  const {
    config: { getter },
    status,
    data
  } = error.response

  let message = NORMAL_ERROR
  if (data) {
    message = lodashGet(data, (getter || {}).message, NETWORK_ERROR)
  }
  logError({
    message,
    config: error.config,
    code: error.code,
    response: error.response
  })
  errorHandlers[status] && errorHandlers[status](data, error.response)
  return Promise.reject(error)
}

function logError({ type = 'error', title = '请求失败', message, config, response, code }) {
  if (response && response.config.silent) return
  message = message || NORMAL_ERROR
  if (type === 'warning') {
    let tipInstance = genErrorMessage(message, config, response, code, 'Message')
    return Message.warning({
      customClass: 'warning-message-class',
      iconClass: 'el-icon-warning warning-icon',
      message: tipInstance?._vnode || message,
      type: 'warning',
      onClose: () => {
        tipInstance?.$destroy?.()
        tipInstance = null
      }
    })
  }
  let tipInstance = genErrorMessage(message, config, response, code)
  Notification({
    type,
    title: title,
    dangerouslyUseHTMLString: true,
    message: tipInstance?._vnode || message,
    onClose: () => {
      tipInstance?.$destroy?.()
      tipInstance = null
    }
  })
}

async function proxyData(data, res) {
  if (!data) return data
  const conf = coverConfig.find(item => res.config.url.indexOf(item.url) >= 0)
  if (!conf) return data
  if (!conf.coverFields || !conf.coverFields.length) return data
  if (conf.coverFields.find(isString)) {
    data = localCover(
      data,
      conf.coverFields.filter(f => typeof f === 'string'),
      conf?.onlyMask || []
    )
  }

  if (conf.coverFields.find(isPlainObject)) {
    // 萨德配置处理
    conf.coverFields.forEach(keyOptions => {
      // 对某一字段批量处理
      if (keyOptions.field && keyOptions.keys && Object.prototype.hasOwnProperty.call(data, keyOptions.field)) {
        const onlyMask = keyOptions.onlyMask || []
        data[keyOptions.field] = localCover(data[keyOptions.field], keyOptions.keys, onlyMask)
      }
    })
  }

  return data
}
